
































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import OnboardingMeetingSchedulingHubspotIframe, {
  IHubspotForm
} from '@/componentsV2/templates/OnboardingMeetingSchedulingHubspotIframe/OnboardingMeetingSchedulingHubspotIframe.vue';
import { OnboardingURL } from '@/views/Onboarding/helpers';
import { removeMerchantInviteState } from '@/router/router-utils';
import { removeSalesOnboardingDataOnSessionStorage } from '@/store/modules/salesOnboarding';

@Component({
  components: { OnboardingMeetingSchedulingHubspotIframe, Typography }
})
export default class OnboardingMeetingScheduling extends Vue {
  @Prop() data?: any;

  get manager() {
    return this.data.managers[0].manager;
  }

  get params() {
    const params: IHubspotForm = {
      firstName: this.manager.name,
      lastName: this.manager.lastname,
      email: this.manager.mail,
      company: this.data.name
    };

    return params;
  }

  handleConfim() {
    removeMerchantInviteState();
    removeSalesOnboardingDataOnSessionStorage();
    this.$router.push(OnboardingURL.WELCOME_TWISM);
  }
}
